import React from 'react';
import {ROUTES} from '@/config/routesConstants';
import BrandHeaderChild from './child-components';

type ChildComponentConfig = {
  matcher: string;
  component: React.ComponentType;
  rightComponent?: React.ComponentType;
  showBackButton?: boolean;
  hideBrandElement?: boolean;
  hideBottomBorder?: boolean;
};

export default function useChildComponents(): ChildComponentConfig[] {
  return [
    // Breadcrumb headers must come before the /campaigns matcher to avoid being shadowed.
    // The /campaigns matcher below is tightened to /campaigns(?!-v2) so campaigns-v2 routes
    // are not accidentally matched by it regardless of ordering.
    {
      matcher: ROUTES.CAMPAIGNS_V2_BRIEF,
      component: BrandHeaderChild.CampaignBreadcrumbsHeader,
      rightComponent: BrandHeaderChild.CampaignOpenBriefButton,
      showBackButton: true,
      hideBrandElement: true,
    },
    {
      matcher: ROUTES.CAMPAIGNS_V2_DETAIL,
      component: BrandHeaderChild.CampaignBreadcrumbsHeader,
      rightComponent: BrandHeaderChild.CampaignOpenBriefButton,
      showBackButton: true,
      hideBrandElement: true,
      // Tabs row (CampaignV2) or content-submission sub-header below already
      // draws the bottom line — avoid a double line between the two rows.
      hideBottomBorder: true,
    },
    {
      matcher: `${ROUTES.CREATOR_CRM}${ROUTES.CREATOR_PROFILE}`,
      component: BrandHeaderChild.CreatorBreadcrumbsHeader,
      showBackButton: true,
      hideBrandElement: true,
    },
    {
      matcher: `${ROUTES.MY_CREATORS}${ROUTES.CREATOR_PROFILE}`,
      component: BrandHeaderChild.ListsBreadcrumbsHeader,
      showBackButton: true,
      hideBrandElement: true,
    },
    // Negative lookahead prevents this from matching /campaigns-v2/* routes.
    {
      matcher: `${ROUTES.CAMPAIGNS}(?!-v2)`,
      component: BrandHeaderChild.Campaigns,
    },
    {matcher: ROUTES.STATS, component: BrandHeaderChild.Stats},
    {
      matcher: '/brief-ai',
      component: BrandHeaderChild.Generic,
      hideBrandElement: true,
    },
  ];
}
